import type { CommunityRole, IdentityStatus } from '../types';

const ROLE_LABELS: Record<CommunityRole,string> = {
  owner:'Owner', admin:'Admin', moderator:'Moderator', member:'Mitglied', guest:'Gast',
};

const CAPABILITY_LABELS: Record<string,string> = {
  view_space:'Raum sehen',
  post_member_channel:'Im Raum schreiben',
  moderate_chat:'Chat moderieren',
  manage_content:'Inhalte verwalten',
  manage_events:'Termine verwalten',
  manage_members:'Menschen verwalten',
  view_member_email:'Kontaktdaten sehen',
  manage_space:'Raum bearbeiten',
  manage_billing:'Zahlungen verwalten',
  assign_admin:'Admins ernennen',
  assign_moderator:'Moderation ernennen',
  assign_member:'Mitglieder hinzufügen',
  assign_guest:'Gäste hinzufügen',
};

const ROLE_MATRIX: Record<CommunityRole,string[]> = {
  owner:Object.keys(CAPABILITY_LABELS),
  admin:['view_space','post_member_channel','moderate_chat','manage_content','manage_events','manage_members','view_member_email','manage_space','assign_moderator','assign_member','assign_guest'],
  moderator:['view_space','post_member_channel','moderate_chat'],
  member:['view_space','post_member_channel'],
  guest:['view_space'],
};

export function IdentityPanel({ status }: { status: IdentityStatus | null }) {
  if (!status) return <div className="identity-empty">Berechtigungen konnten noch nicht gelesen werden.</div>;
  const identityLabel = status.identity.auth_linked
    ? status.identity.migration_status === 'verified' ? 'Neue Identität verifiziert' : 'Neue Identität verbunden'
    : 'Bestehender Zugang bleibt führend';

  return <div className="identity-panel">
    <section className="identity-summary">
      <div><span>IDENTITÄT</span><strong>{identityLabel}</strong><small>{status.identity.auth_linked ? 'Supabase Auth ist verknüpft.' : 'Keine automatische Umstellung, keine neue Phrase.'}</small></div>
      <b className={status.identity.auth_linked ? 'linked' : 'legacy'}>{status.identity.migration_status}</b>
    </section>

    <section className="identity-spaces">
      <header><span>DEINE ROLLEN</span><h3>Rechte gelten immer pro Raum</h3></header>
      {status.spaces.map(space => <article key={space.space_id}>
        <div><strong>{space.title}</strong><small>{ROLE_LABELS[space.role]}</small></div>
        <ul>{space.capabilities.map(capability => <li key={capability}>{CAPABILITY_LABELS[capability] || capability}</li>)}</ul>
      </article>)}
    </section>

    <section className="role-matrix" aria-label="Rollen und Berechtigungen">
      <header><span>ROLLENMODELL</span><h3>Eine Hierarchie, serverseitig geprüft</h3><p>Eine niedrigere Rolle kann niemals eine höhere Rolle verändern. Der letzte Owner bleibt geschützt.</p></header>
      <div className="role-matrix-grid">
        {status.role_order.map(role => <article key={role}>
          <strong>{ROLE_LABELS[role]}</strong>
          <small>{ROLE_MATRIX[role].map(item => CAPABILITY_LABELS[item]).join(' · ')}</small>
        </article>)}
      </div>
    </section>
  </div>;
}
